import {intent} from './ui/intent'

intent.setup()



// WEBPACK FOOTER //
// ./src/assets/scripts/site.js